<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Blank'
  }
</script>



// WEBPACK FOOTER //
// src/components/blank.vue